import * as actions from "../actions/actions";
import * as actionTypes from "../actions/actionTypes";

import { connect } from "react-redux";

import Icon from "./nounproject-ui-icon";
import Loading from "./loading";
import React from "react";
import PropTypes from "prop-types";

var tinycolor = require("tinycolor2");

class IconListIcon extends React.Component {
    static defaultProps = {
        icon: {},
        size: {}
    };
    static propTypes = {
        icon: PropTypes.object.isRequired,
        size: PropTypes.object.isRequired
    };

    componentWillReceiveProps(nextProps) {
        if (nextProps.apiResponse) {
            if (
                (nextProps.apiResponse.actionType ===
                    actionTypes.FETCH_PNG_DATA_SUCCESS &&
                    this.state.insertLoading) ||
                (nextProps.apiResponse.actionType ===
                    actionTypes.REPORT_PLUGIN_USAGE_SUCCESS &&
                    this.state.insertLoading) ||
                (nextProps.apiResponse.actionType ===
                    actionTypes.REPORT_PLUGIN_USAGE_FAILURE &&
                    this.state.insertLoading)
            ) {
                setTimeout(() => {
                    this.setState({
                        insertLoading: false,
                        isInserting: true
                    });
                }, 3000);
            } else {
                this.setState({
                    isInserting: false
                });
            }
        }
    }

    constructor(props) {
        super(props);

        this.state = {
            imageIsLoaded: false
        };
    }

    imageLoaded(event) {
        this.setState({
            imageIsLoaded: true,
            insertLoading: false,
            isInserting: false
        });
    }

    placeIcon(e) {
        let assetData,
            color = this.props.selectedColor.hex;

        // Force capitalization
        color = color.toUpperCase();

        if (color === "BLACK") {
            color = "#000000";
        } else if (color === "WHITE") {
            color = "#ffffff";
        }

        switch (this.props.host) {
            case "office":
                assetData = {
                    icon_id: this.props.icon.id,
                    color: color.replace("#", "")
                };

                this.setState({ insertLoading: true });
                break;
            case "adobe":
                let fileType = this.props.host === "office" ? "png" : "svg",
                    size;
                this.props.reportPluginUsage(
                    this.props.icon.id,
                    `${this.props.host}_plugin`,
                    fileType,
                    color
                );

                if (this.props.imgChoices.selectedSize === "custom") {
                    size = parseInt(this.props.imgChoices.sizes["custom"].size);
                } else {
                    size = parseInt(
                        this.props.imgChoices.sizes[
                            parseInt(this.props.imgChoices.selectedSize)
                        ].size
                    );
                }

                this.setState({ insertLoading: true });
                if (this.props.adobeAgent === "IDSN") {
                    return this.props.placePluginPDF(
                        this.props.icon,
                        color.replace("#", ""),
                        size
                    );
                } else {
                    return this.props.placePluginSVG(
                        this.props.icon,
                        this.props.selectedColor,
                        size
                    );
                }
                break;
            case "gsuite":
                this.setState({ insertLoading: true });
                this.props.placePluginPNGGSuite(
                    this.props.icon,
                    color.replace("#", ""),
                    size
                );
                this.props.reportPluginUsage(
                    this.props.icon.id,
                    `${this.props.host}_plugin`,
                    "png",
                    color
                );
                break;
        }

        if (this.props.icon.freemium) {
            this.placeIconAction(assetData);
        } else {
            if (this.props.currentUser.has_premium_account) {
                this.placeIconAction(assetData);
            }
        }
    }

    placeIconAction(assetData) {
        let fileType = this.props.host === "office" ? "png" : "svg",
            size;
        this.props.reportPluginUsage(
            this.props.icon.id,
            `${this.props.host}_plugin`,
            fileType,
            this.props.selectedColor.hex
        );

        if (this.props.imgChoices.selectedSize === "custom") {
            size = parseInt(this.props.imgChoices.sizes["custom"].size);
        } else {
            size = parseInt(
                this.props.imgChoices.sizes[
                    parseInt(this.props.imgChoices.selectedSize)
                ].size
            );
        }

        if (this.props.host === "adobe") {
            return this.props.placePluginSVG(
                this.props.icon,
                this.props.selectedColor,
                this.props.imgChoices.selectedSize
            );
        }
        if (this.props.host === "office") {
            return this.props.placePluginPNG(assetData, size, this.props.host);
        }
    }

    onClickAction(e) {
        if (this.props.showIconDetail) {
            e.preventDefault();

            this.props.setActiveIcon(this.props.icon.id);

            if (this.props.host !== undefined) {
                // scroll up in plugin
                $("html, body").animate(
                    {
                        scrollTop: 0
                    },
                    700
                );
            }
        }
    }

    render() {
        let backgroundIMG,
            iconIMG = this.renderIconImg(),
            imgSrc = this.renderIconInfo().imgSrc,
            widthClass = this.renderIconInfo().width,
            heightClass = this.renderIconInfo().height,
            hover = this.renderIconHover();

        if (!this.props.dragAndDrop) {
            let backgroundIMGClasses = ["cell-background-img"];
            if (this.state.isInserting) {
                backgroundIMGClasses.push("insertIconNow");
            }
            backgroundIMG = (
                <div
                    className={backgroundIMGClasses.join(" ")}
                    style={{
                        backgroundImage: `url(${imgSrc})`,
                        backgroundSize: "90%",
                        backgroundRepeat: "no-repeat",
                        backgroundPosition: "center center",
                        display: "block",
                        width: widthClass,
                        height: heightClass
                    }}
                />
            );
        }

        return (
            <div
                className={`Grid-cell ${
                    this.state.imageIsLoaded ? "loaded" : ""
                }`}
                style={this.props.size}
            >
                {hover}
                <a
                    href={`${this.props.icon.permalink}?i=${
                        this.props.icon.id
                    }`}
                    title={this.props.icon.term + ". Click for details"}
                    onClick={this.onClickAction.bind(this)}
                >
                    {backgroundIMG}
                    {iconIMG}
                </a>
            </div>
        );
    }

    renderIconHover() {
        let hover,
            selectedColor,
            quickPlaceIconColor = "#FFFFFF",
            quickPlaceIcon = (
                <Icon
                    iconId="lock.svg"
                    className="icon-fit"
                    color={quickPlaceIconColor}
                    width="100%"
                    height="100%"
                />
            ),
            quickPlaceStyles = null,
            quickPlaceTitle = "Unlock with NounPro",
            quickPlaceButtonAction;

        if (this.props.selectedColor) {
            selectedColor = tinycolor(this.props.selectedColor.hex);

            if (
                this.props.currentUser.has_premium_account ||
                this.props.icon.freemium
            ) {
                quickPlaceButtonAction = this.state.insertLoading
                    ? null
                    : this.placeIcon.bind(this);

                if (selectedColor.isLight()) {
                    quickPlaceIconColor = "#000000";
                }
                quickPlaceIcon = (
                    <Icon
                        iconId="download.svg"
                        className="icon-fit"
                        color={quickPlaceIconColor}
                        width="100%"
                        height="100%"
                    />
                );
                quickPlaceStyles = {
                    backgroundColor: this.props.selectedColor.hex
                };
                quickPlaceTitle =
                    "Insert at " +
                    this.props.imgChoices.selectedSize +
                    " (" +
                    this.props.selectedColor.hex +
                    ")";
            }
        }

        if (this.props.host !== undefined) {
            let hoverClasses = ["icon-hover"];

            if (this.state.insertLoading) {
                hoverClasses.push("processing");
                quickPlaceIcon = <Loading />;
            }

            hover = (
                <div className={hoverClasses.join(" ")}>
                    <div
                        className="quick-place-button"
                        onClick={quickPlaceButtonAction}
                        style={quickPlaceStyles}
                        title={quickPlaceTitle}
                    >
                        {quickPlaceIcon}
                    </div>
                </div>
            );
        }

        return hover;
    }

    renderIconInfo() {
        let heightClass, iconSize, imgSrc, widthClass;

        switch (this.props.size.width) {
            case "42px":
                // non-retina image size (42px)
                if (this.props.icon.preview_url_42) {
                    iconSize = this.props.icon.preview_url_42;
                } else if (this.props.icon.preview_url_84) {
                    iconSize = this.props.icon.preview_url_84;
                } else {
                    iconSize = this.props.icon.preview_url;
                }

                imgSrc = iconSize;
                widthClass = "42px";
                heightClass = "42px";

                if (window.devicePixelRatio === 2) {
                    // retina 2x image size (84px)
                    imgSrc = this.props.icon.preview_url_84;
                }
                break;
            case "84px":
                // non-retina image size (84px)
                if (this.props.icon.preview_url_84) {
                    iconSize = this.props.icon.preview_url_84;
                } else {
                    iconSize = this.props.icon.preview_url;
                }
                imgSrc = iconSize;
                widthClass = "84px";
                heightClass = "84px";

                if (window.devicePixelRatio === 2) {
                    // retina 2x image size (200px)
                    imgSrc = this.props.icon.preview_url;
                }
                break;
        }

        return { imgSrc: imgSrc, width: widthClass, height: heightClass };
    }

    renderIconImg() {
        let imgSrc = this.renderIconInfo().imgSrc,
            widthClass = this.renderIconInfo().width,
            heightClass = this.renderIconInfo().height;

        return (
            <img
                src={imgSrc}
                style={{
                    visibility: !this.props.dragAndDrop ? "hidden" : "visible",
                    width: `${widthClass}`,
                    height: `${heightClass}`
                }}
                onLoad={this.imageLoaded.bind(this)}
            />
        );
    }
}

function mapStateToProps(state, ownProps) {
    let apiResponse = state.apiResponse,
        currentUser = state.user,
        host = state.plugin.host,
        adobeAgent = state.plugin.adobeAgent,
        imgChoices,
        selectedColor,
        showIconDetail = state.icons.show_icon_detail;

    if (state.icons.selectedColor) {
        selectedColor = state.icons.selectedColor;
    }

    if (state.icons.imgChoices) {
        imgChoices = state.icons.imgChoices;
    }

    return {
        apiResponse,
        currentUser,
        showIconDetail,
        host,
        selectedColor,
        imgChoices,
        adobeAgent
    };
}

export default connect(
    mapStateToProps,
    {
        placePluginPDF: actions.placePluginPDF,
        placePluginSVG: actions.placePluginSVG,
        placePluginPNG: actions.placePluginPNG,
        placePluginPNGGSuite: actions.placePluginPNGGSuite,
        reportPluginUsage: actions.reportPluginUsage,
        setActiveIcon: actions.setActiveIcon
    }
)(IconListIcon);
